import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  active!: boolean;

  constructor() { }

  start() {
    setTimeout(() => {
      this.active = true;
    });
  }

  stop() {
    setTimeout(() => {
      this.active = false;
    });
  }
}
